module.exports = __webpack_public_path__ + "img/2_249.3f65d4ca.png";